import { ComponentProps, PropsWithChildren, ReactElement, useState } from 'react';
import { IoMdEyeOff, IoMdEye } from 'react-icons/io';
import styles from './input.module.css';

export type InputProps = ComponentProps<'input'> & {
    id: string;
    preset?: 'text' | 'password';
    error?: boolean;
    placeholder?: string;
    helper?: string;
    className?: string;
    style?: React.CSSProperties;
    containerClassName?: string;
    containerStyle?: React.CSSProperties;
    icon?: ReactElement;
};

export function Input({
    preset = 'text',
    id,
    error,
    helper,
    className,
    style,
    containerClassName,
    containerStyle,
    children,
    icon,
    ...rest
}: PropsWithChildren<InputProps>) {
    const containerClasses = `${styles.container} ${containerClassName} `;
    const labelClasses = `${styles.label} `;
    const inputClasses = `${styles.input} ${className} ${error && styles.inputError} ${icon && styles.inputWithIcon} `;
    const helperClasses = `${styles.helper} ${error && styles.helpError} `;

    const [passwordType, setPasswordType] = useState(preset);
    const toggleShow = () => setPasswordType(passwordType === 'password' ? 'text' : 'password');
    const inputType = preset === 'password' ? passwordType : preset;
    const EyeIcon = inputType === 'password' ? IoMdEye : IoMdEyeOff;

    return (
        <div className={containerClasses} style={containerStyle}>
            {children && (
                <label className={labelClasses} htmlFor={id}>
                    {children}
                </label>
            )}
            <div className={styles.inputContainer}>
                {icon && <div className={styles.inputIcon}>{icon}</div>}
                <input type={inputType} name={id} id={id} className={inputClasses} style={style} {...rest} />
                {preset === 'password' && <EyeIcon className={styles.hideShow} size={20} onClick={toggleShow} />}
            </div>
            {helper && <p className={helperClasses}>{helper}</p>}
        </div>
    );
}
